import { render, staticRenderFns } from "./ARecordForm.vue?vue&type=template&id=7469a707&"
import script from "./ARecordForm.vue?vue&type=script&lang=js&"
export * from "./ARecordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7469a707')) {
      api.createRecord('7469a707', component.options)
    } else {
      api.reload('7469a707', component.options)
    }
    module.hot.accept("./ARecordForm.vue?vue&type=template&id=7469a707&", function () {
      api.rerender('7469a707', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Domains/ZoneEditor/Records/ARecordForm.vue"
export default component.exports